import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { Box, Checkbox, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { NearMe } from "@mui/icons-material";

function Row(props) {
  const {
    row,
    columns,
    isAllExpanded,
    selectedRows,
    onCheckboxChange,
    idRow,
    isEnabledSelection,
    alwaysExpanded,
  } = props;
  const [open, setOpen] = useState(false);

  const isSelected = selectedRows.includes(row[idRow]);

  useEffect(() => {
    setOpen(isAllExpanded);
  }, [isAllExpanded]);

  const handleCheckboxChange = (e) => {
    const newChecked = e.target.checked;
    if (onCheckboxChange) {
      onCheckboxChange(row[idRow], newChecked);
    }
  };

  return (
    <>
      <TableRow key={row[idRow]} sx={{ "& > *": { borderBottom: "unset" } }}>
        {isEnabledSelection ? (
          <TableCell padding="checkbox">
            <Checkbox
              sx={{ ml: 1 }}
              checked={isSelected}
              onChange={handleCheckboxChange}
            />
          </TableCell>
        ) : (
          ""
        )}
        {!alwaysExpanded ? (
          <TableCell padding="checkbox">
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <RemoveIcon /> : <AddIcon />}
            </IconButton>
          </TableCell>
        ) : (
          ""
        )}
        {columns.map((column, index) => (
          <TableCell key={index} padding="none" sx={{width: column?.width != null ? column.width : 100}} align="left">
            <Typography sx={{ ml:0.2, mr:0.2 }} variant="subtitle2">
            {column.renderCell !== null && column.renderCell != undefined ? (
                column.renderCell({ row: row })
            ) : (
              row[column.field]
            )}
            </Typography>
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={columns.length + 2}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ p: 0.5 }}>
              <Grid container spacing={2}>
                {props.renderExpanded(row)}
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

Row.propTypes = {
  row: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  isAllExpanded: PropTypes.bool.isRequired,
  selectedRows: PropTypes.array.isRequired,
  onCheckboxChange: PropTypes.func,
};

const ExpandableCustomTable = (props) => {
  const { rows, columns, id, size, name } = props;
  var alwaysExpanded =
    props?.alwaysExpanded !== undefined ? props.alwaysExpanded : false;
  const [isAllExpanded, setIsAllExpanded] = useState(alwaysExpanded);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);

  const handleExpandAll = () => {
    setIsAllExpanded(!isAllExpanded);
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setSelectedRows(rows.map((row) => row[id]));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowCheckboxChange = (rowId, isChecked) => {
    if (isChecked) {
      setSelectedRows((prev) => [...prev, rowId]);
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== rowId));
    }
  };

  useEffect(() => {
    setIsAllSelected(selectedRows.length === rows.length);
    if (
      props.OnChangeSelectedRows !== null &&
      props.OnChangeSelectedRows !== undefined
    ) {
      props.OnChangeSelectedRows(selectedRows);
    }
  }, [selectedRows]);

  useEffect(() => {
  }, [rows, columns]);

  return (
    <TableContainer component={Paper}>
      <Table
        size={size === undefined ? "small" : size}
        aria-label={name === undefined ? "collapsible table" : name}
      >
        <TableHead>
          <TableRow>
            {props.isEnabledSelection ? (
              <TableCell
                padding="checkbox"
                sx={{ width: 10 }}
                className={props.defaultHeaderClass}
              >
                <Checkbox
                  sx={{ ml: 1 }}
                  checked={isAllSelected}
                  onChange={handleSelectAll}
                  indeterminate={selectedRows.length > 0 && !isAllSelected}
                />
              </TableCell>
            ) : (
              ""
            )}
            {!alwaysExpanded ? (
              <TableCell
                padding="checkbox"
                sx={{ width: 10 }}
                className={props.defaultHeaderClass}
              >
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={handleExpandAll}
                >
                  {isAllExpanded ? <RemoveIcon /> : <AddIcon />}
                </IconButton>
              </TableCell>
            ) : (
              ""
            )}
            {columns.map((column, index) => (
              <TableCell key={index} padding="none" className={column?.className !== undefined ? `${column?.className}`: ""} sx={{width: column?.width != null ? column.width : 100}} align="left">
                <Typography sx={{ ml:0.2, mr:0.2, color: "white" }} >
                  {
                    column.renderHeader === null || column.renderHeader === undefined 
                    ? column.field
                    : column.renderHeader()
                  }
                </Typography>
                
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {rows?.length > 0 ? (
          <TableBody>
            {rows?.map((row, index) => (
              <Row
                key={index}
                idRow={id}
                row={row}
                columns={columns}
                isAllExpanded={isAllExpanded}
                selectedRows={selectedRows}
                onCheckboxChange={handleRowCheckboxChange}
                renderExpanded={props.renderExpanded}
                isEnabledSelection={props.isEnabledSelection}
                alwaysExpanded={alwaysExpanded}
              />
            ))}
          </TableBody>
        ) : (
          <TableBody></TableBody>
        )}
      </Table>
    </TableContainer>
  );
};

export default ExpandableCustomTable;
